export default function ContentElementText(Element) {
  return (
    <div
      className="prose-sm md:prose dark:!text-foreground content-element-padding dark:prose-strong:text-foreground"
      dangerouslySetInnerHTML={{ __html: Element.text }}
    />
  );
}
